import smoothscroll from 'smoothscroll-polyfill';
import debounce from 'lodash/debounce';
import domReady from '../helpers/dom-ready';

class WCSelectedProducts {
  static init(...parameters) {
    return new WCSelectedProducts(...parameters);
  }

  constructor() {
    this.container = document.querySelector('.selected-products-wrapper');
    if (this.container) {
      this.scrollWrapper = this.container.querySelector('.scroll-wrapper');
      this.posts = this.container.querySelector('.products');
      this.scrollLeftButton = this.container.querySelector('.scroll-button.-left');
      this.scrollRightButton = this.container.querySelector('.scroll-button.-right');
      this.images = this.container.querySelectorAll('.image-wrapper');

      const imageWidth = this.images[0].clientWidth;

      this.scrollLeftButton.addEventListener('click', () => {
        const scrollDistance = window.innerWidth < 576 ? -imageWidth - 24 : -imageWidth - 40;

        this.posts.scrollBy({
          top: 0,
          left: scrollDistance,
          behavior: 'smooth',
        });
      });

      this.scrollRightButton.addEventListener('click', () => {
        const scrollDistance = window.innerWidth < 576 ? imageWidth + 24 : imageWidth + 40;

        this.posts.scrollBy({
          top: 0,
          left: scrollDistance,
          behavior: 'smooth',
        });
      });

      smoothscroll.polyfill();

      this.toggleScrollControls();

      window.addEventListener('resize', debounce(() => { this.toggleScrollControls(); }, 50));
      this.posts.addEventListener('scroll', debounce(() => { this.toggleButtonVisibility(); }, 50));
    }
  }

  toggleScrollControls() {
    if (this.posts && this.scrollWrapper) {
      if (this.posts.scrollWidth > this.scrollWrapper.offsetWidth) {
        this.toggleButtonVisibility();
      } else {
        this.scrollLeftButton.classList.add('-hide');
        this.scrollRightButton.classList.add('-hide');
      }
    }
  }

  toggleButtonVisibility() {
    this.scrollRightButton.classList.remove('-hide');

    // Show left scroll button
    if (this.posts.scrollLeft > 1 && this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollLeftButton.classList.remove('-hide');
    }

    // Hide left scroll button
    if (this.posts.scrollLeft < 1 && !this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollLeftButton.classList.add('-hide');
    }

    // Show right scroll button
    if (this.posts.scrollLeft > 1 && this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollRightButton.classList.remove('-hide');
    }

    // Show right scroll button
    if (this.posts.scrollLeft + this.posts.offsetWidth
      <= this.posts.scrollWidth && this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollRightButton.classList.remove('-hide');
    }

    // Hide right scroll button
    if (this.posts.scrollLeft + this.posts.offsetWidth
      >= this.posts.scrollWidth && !this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollRightButton.classList.add('-hide');
    }
  }
}

domReady(() => {
  WCSelectedProducts.init();
});
